// removed by extract-text-webpack-plugin
module.exports = {"container":"_2AInel7O3yMTox5Z8OTaet","answerContainer":"_2GjgAJhaNoiYmAXWBmq9lZ","button":"_19GOWWiGNhYYi9QMb9EtJe","buttonIsSelectd":"_1pU1X1VxcjqwoCtaZ3VtO2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnswerGroup/styles.css
// module id = 384
// module chunks = 0